import { render, staticRenderFns } from "./EnviarLaudosPacs.vue?vue&type=template&id=7ff9a006&"
import script from "./EnviarLaudosPacs.vue?vue&type=script&lang=js&"
export * from "./EnviarLaudosPacs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports